import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { setAuthToken } from "modules/auth/lib/setAuthToken"
import { BackofficeImpersonateOrganizationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeImpersonateOrganizationResponseDataSchema>>

export function useImpersonateEmployeeMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (employeeId: string) => {
      const response = await axios.get<Response>(`/employees/${employeeId}/impersonate`)
      return response.data.data
    },
    onSuccess: (data) => {
      setAuthToken({ queryClient, token: data.token })
      window.location.href = "/"
    },
  })
}
